import type { LucideIcon } from 'lucide-react';
import BadgeAlert from 'lucide-react/dist/esm/icons/badge-alert';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  description: string;
  action?: ReactNode;
  icon?: LucideIcon;
  showIcon?: boolean;
}

export function EmptyState({
  title,
  description,
  action,
  icon: Icon = BadgeAlert,
  showIcon = true
}: Props) {
  return (
    <div
      data-slot="empty-state"
      role="status"
      className="flex min-h-0 flex-1 flex-col items-center justify-center p-8"
    >
      <div className="max-w-md text-center">
        {showIcon ? (
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
            <Icon className="h-8 w-8" />
          </div>
        ) : null}
        <h3 className="mb-2 text-lg font-medium text-foreground">{title}</h3>
        <p className="text-muted-foreground">{description}</p>
        {action ? (
          <div className="mt-4 flex flex-wrap items-center justify-center gap-2">{action}</div>
        ) : null}
      </div>
    </div>
  );
}
